import { errorProxy } from './chunk-JMNS64QU.mjs';
import { globalSettingsSchema } from './chunk-OFEPDH3Z.mjs';
import { NotFoundError, UnknownError } from './chunk-CN37FTGW.mjs';
import { doc, collection, onSnapshot, getDoc } from 'firebase/firestore';
import { fromPromise, errAsync, okAsync } from 'neverthrow';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

var globalSettingsCollection = (db) => {
  return collection(db, "global_settings");
};

// src/bloc/global-settings/index.ts
var globalSettingsBlocFactory = (db) => {
  const companyDocRef = doc(globalSettingsCollection(db), "company");
  const clientDocRef = doc(globalSettingsCollection(db), "client");
  const adminDocRef = doc(globalSettingsCollection(db), "admin");
  const formDocRef = doc(globalSettingsCollection(db), "form");
  const stream = () => {
    const company$ = new Observable((subscriber) => {
      const unsubscribe = onSnapshot(
        companyDocRef,
        (snapshot) => {
          if (!snapshot.exists()) {
            subscriber.error(new NotFoundError("Company \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
          } else {
            subscriber.next(snapshot);
          }
        },
        (error) => subscriber.error(error)
      );
      return unsubscribe;
    });
    const client$ = new Observable((subscriber) => {
      const unsubscribe = onSnapshot(
        clientDocRef,
        (snapshot) => {
          if (!snapshot.exists()) {
            subscriber.error(new NotFoundError("Client \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
          } else {
            subscriber.next(snapshot);
          }
        },
        (error) => subscriber.error(error)
      );
      return unsubscribe;
    });
    const admin$ = new Observable((subscriber) => {
      const unsubscribe = onSnapshot(
        adminDocRef,
        (snapshot) => {
          if (!snapshot.exists()) {
            subscriber.error(new NotFoundError("Admin \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
          } else {
            subscriber.next(snapshot);
          }
        },
        (error) => subscriber.error(error)
      );
      return unsubscribe;
    });
    const form$ = new Observable((subscriber) => {
      const unsubscribe = onSnapshot(
        formDocRef,
        (snapshot) => {
          subscriber.next(snapshot);
        },
        (error) => subscriber.error(error)
      );
      return unsubscribe;
    });
    return combineLatest([company$, client$, admin$, form$]).pipe(
      map(([companySnap, clientSnap, adminSnap, formSnap]) => {
        const combined = {
          shared: {
            company: companySnap.data(),
            form: formSnap.exists() ? formSnap.data() : void 0
          },
          client: {
            ...clientSnap.data(),
            get loginMethod() {
              var _a;
              const loginMethod = (_a = clientSnap.data()) == null ? void 0 : _a.loginMethod;
              if (loginMethod === void 0 || !Array.isArray(loginMethod)) return ["google"];
              return loginMethod.length > 0 ? loginMethod : ["google"];
            }
          },
          admin: {
            ...adminSnap.data(),
            get loginMethod() {
              var _a;
              const loginMethod = (_a = adminSnap.data()) == null ? void 0 : _a.loginMethod;
              if (loginMethod === void 0 || !Array.isArray(loginMethod)) return ["google"];
              return loginMethod.length > 0 ? loginMethod : ["google"];
            }
          }
        };
        const parsed = globalSettingsSchema.safeParse(combined);
        if (!parsed.success) {
          throw new UnknownError("parse global settings failed", { cause: parsed.error });
        }
        return parsed.data;
      })
    );
  };
  const get = () => {
    return fromPromise(Promise.all([getDoc(companyDocRef), getDoc(clientDocRef), getDoc(adminDocRef), getDoc(formDocRef)]), errorProxy("fetch global settings failed")).andThen(
      (snapshots) => {
        const [companySnap, clientSnap, adminSnap, formSnap] = snapshots;
        if (!companySnap.exists()) {
          return errAsync(new NotFoundError("Company \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
        }
        if (!clientSnap.exists()) {
          return errAsync(new NotFoundError("Client \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
        }
        if (!adminSnap.exists()) {
          return errAsync(new NotFoundError("Admin \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002"));
        }
        const combined = {
          shared: {
            company: companySnap.data(),
            form: formSnap.exists() ? formSnap.data() : void 0
          },
          client: {
            ...clientSnap.data(),
            get loginMethod() {
              const loginMethod = clientSnap.data().loginMethod;
              if (loginMethod === void 0 || !Array.isArray(loginMethod)) return ["google"];
              return loginMethod.length > 0 ? loginMethod : ["google"];
            }
          },
          admin: {
            ...adminSnap.data(),
            get loginMethod() {
              const loginMethod = adminSnap.data().loginMethod;
              if (loginMethod === void 0 || !Array.isArray(loginMethod)) return ["google"];
              return loginMethod.length > 0 ? loginMethod : ["google"];
            }
          }
        };
        const result = globalSettingsSchema.safeParse(combined);
        if (!result.success) {
          return errAsync(new UnknownError("parse global settings failed", { cause: result.error }));
        }
        return okAsync(result.data);
      }
    );
  };
  return { stream, get };
};

export { globalSettingsBlocFactory };
//# sourceMappingURL=chunk-JSTC4PPE.mjs.map
//# sourceMappingURL=chunk-JSTC4PPE.mjs.map